import { render, staticRenderFns } from "./TagDialog.vue?vue&type=template&id=fa8d2826&scoped=true"
import script from "./TagDialog.vue?vue&type=script&lang=js"
export * from "./TagDialog.vue?vue&type=script&lang=js"
import style0 from "./TagDialog.vue?vue&type=style&index=0&id=fa8d2826&prod&lang=scss&scoped=true"
import style1 from "./TagDialog.vue?vue&type=style&index=1&id=fa8d2826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8d2826",
  null
  
)

export default component.exports